<script>
  import { asteroid, collections, Subscriber } from "@/meteor";
  import { formatNumber } from "@/utils";
  import dayjs from "dayjs";

  const subscribe = Subscriber("metas");
  $subscribe;

  const metas = collections.metas;

  $: metaMap = Object.values($metas).reduce((map, meta) => {
    map[meta.key] = meta;
    return map;
  }, {});

  let updatingStock = false;
  async function updateStock() {
    updatingStock = true;
    await asteroid.call("metas.refreshStockTotal");
    updatingStock = false;
  }

  $: staleStockValue =
    metaMap.lastProductUpdate &&
    metaMap.stockTotal &&
    metaMap.stockTotal.updatedAt.$date < metaMap.lastProductUpdate.value.$date;

  $: console.log(metaMap);
</script>

<style>
  .halfnhalf {
    @apply flex flex-wrap;
  }
  .halfnhalf > h5 {
    @apply font-semibold w-32;
  }
  .halfnhalf > span {
  }
</style>

<div class="flex flex-wrap justify-center pt-12 px-4 text-xl">
  {#if metaMap.stockTotal}
    <div class="sm:w-2/3 w-full">
      <div>
        <span class="text-3xl align-middle">Varelager</span>
        {#if staleStockValue && !updatingStock}
          <button
            class="absolute ml-8 btn outline gray sm align-middle"
            on:click={updateStock}>
            Opdater
          </button>
        {/if}
      </div>
      <div class="halfnhalf">
        <h5>Værdi</h5>
        <span>{formatNumber(metaMap.stockTotal.value.sum, 2)} kr</span>

      </div>
      <div class="halfnhalf">
        <h5>Sortiment</h5>
        <span>{metaMap.stockTotal.value.uniqueProducts}</span>
      </div>
      <div class="halfnhalf">
        <h5>Varer</h5>
        <span>{metaMap.stockTotal.value.totalProducts}</span>
      </div>
      {#if staleStockValue}
        <div class="text-gray-600 text-base font-semibold">
          Opdateret {dayjs(metaMap.stockTotal.updatedAt.$date).format('DD-MM-YYYY HH-mm')}
        </div>
      {/if}
      <div />

    </div>
  {/if}

  <div class=" text-gray-500">
    <a href="/batch">Indlæs csv</a>
  </div>
</div>
